<template>
	<div>
		<el-card class="box-card">
			<div style="display: flex;background: white">
				<div style="width: 50%;text-align: left;display: flex">
					<el-upload
							class="upload-demo"
							ref="upload"
							:action="uploadurl"
							:on-preview="handlePreview"
							:on-remove="handleRemove"
							:on-change="handleChange"
							:on-success="handleSuccess"
							:on-error="handleError"
							:file-list="fileList"
							:limit="1"
							accept=".xlsx"
							style="margin-left: 8px"
					>
						<el-button slot="trigger" size="mini" type="primary">{{$t('getapi[6507]')}}</el-button>
					</el-upload>
				</div>

				<div style="width: 50%;text-align: right">
					<el-button type="primary" size="mini" @click="check">{{$t('getapi[439]')}}</el-button>
					<el-button type="primary" size="mini" @click="save" :disabled="!ischeck">{{$t('getapi[370]')}}</el-button>
				</div>
			</div>
		</el-card>
		<div id="xpane-0">
			<vxe-table
					:data="datajson"
					show-overflow
					ref='CloseSoTable'
					size="mini" :loading="loading"  :height="tableHeight" stripe border resizable>
				<vxe-table-column type="checkbox" align="center" width="60"></vxe-table-column>
				<vxe-table-column show-footer-overflow field="errormsg" :title="$t('getapi[357]')" width="150px">
				</vxe-table-column>
				<vxe-table-column show-footer-overflow field="model_id" :title="$t('getapi[6841]')" width="100" ></vxe-table-column>
				<vxe-table-column show-footer-overflow field="model_name" :title="$t('getapi[6842]')" width="100" ></vxe-table-column>
				<vxe-table-column show-footer-overflow field="model_help" :title="$t('getapi[7371]')" width="150px"></vxe-table-column>
				<vxe-table-column show-footer-overflow field="group_name" :title="$t('getapi[8826]')" width="100" ></vxe-table-column>
			</vxe-table>
		</div>
	</div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';
    export default {
        name:'modelhelpimp',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight2
            }
        },
        data() {
            return {
                fileList: [],
                itevisible:false,
                ids: '',
                showloading: '',
                DbTbNames: '', //表名
                datajson: [],
                loading: false, // 主表加载状态
                uploadurl: '',
                ischeck: false,
                scrollTop:0,
            };
        },
        created () {
            setTimeout(() => {
                this.datajson = [];
            }, 1000)
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/Sys/Currency/ModelHelpImportToUpFile?token=' + token;
            this.btnauthority();
        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(0)
                    }, 500);
                })
            },
        },
        mounted() {
            console.log('mounted');
            this.btnauthority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.CloseSoTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.CloseSoTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            btnauthority() {
                let that = this;
            },
            handleChange(file, fileList) {
                let that = this;
                that.loading = true;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        if(file.response.DataContent.length>0){
                            that.datajson = file.response.DataContent;
                        }else{
                            that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                        }
                    }
                    that.loading = false;
                }
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    if(res.DataContent.length>0){
                        that.datajson = res.DataContent;
                        that.ischeck = false
                    }else{
                        that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                    }

                }
                that.fileList=[];
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview"+file);
            },
            //校验
            check() {
                let that = this
                let lan = that.$processdata.getLang()
                for(let i=0;i<that.datajson.length;i++){
                    that.datajson[i].LangType= lan
                }
                let parm = that.datajson
                that.$http.urlpost('/Sys/Currency/ModelHelpToImportCheck', parm, function (res) {
                    if (res.Success == 1) {
                        that.datajson = res.DataContent.dt
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.ischeck = true
                    } else {
                        that.datajson = res.DataContent.dt
                    }
                });
            },
            // 保存备注数据
            save() {
                let that = this;
                if(that.datajson.length==0){
                    that.$message.warning(that.$t('getapi[8712]'));//'请添加导入数据！'
                    return;
                }
                this.$confirm('此操作会覆盖原先数据,请确实是否继续？', that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = that.datajson
                        that.$http.urlpost('/Sys/Currency/ModelHelpToImportSave', parm, function (res) {
                            if (res.Success == 1) {
                                that.datajson=[];
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                            } else if(res.Success == 2){
                                that.datajson = res.DataContent.dt
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });

            },
        }
    };
</script>

<style lang="scss" scoped>
	span.label-fade-enter {
		font-size: medium;
		margin-right: 20px;
	}
</style>
<style>
	.el-message-box {
		width: 600px;
	}
</style>
